import * as React from "react";
import { cn } from "./utils";
import { Crown, Rocket, Sparkles, Star } from "lucide-react";

export interface SubscriptionPlanBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    plan: string | null | undefined;
}

const planConfig = {
    trial: {
        color: "bg-slate-100 text-slate-800 border-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:border-slate-700",
        label: "Free",
        icon: <Sparkles size={20} />,
    },
    starter: {
        color: "bg-cyan-100 text-cyan-800 border-cyan-200 dark:bg-cyan-900 dark:text-cyan-100 dark:border-cyan-700",
        label: "Starter",
        icon: <Rocket size={20} />,
    },
    pro: {
        color: "bg-violet-100 text-violet-800 border-violet-200 dark:bg-violet-900 dark:text-violet-100 dark:border-violet-700",
        label: "Pro",
        icon: <Star size={20} />,
    },
    enterprise: {
        color: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900 dark:text-amber-100 dark:border-amber-700",
        label: "Enterprise",
        icon: <Crown size={20} />,
    },
};

const SubscriptionPlanBadge = React.forwardRef<HTMLSpanElement, SubscriptionPlanBadgeProps>(
    ({ className, plan, ...props }, ref) => {
        if (!plan) {
            return (
                <span
                    ref={ref}
                    className={cn(
                        "inline-flex items-center gap-1.5 bg-gray-100 dark:bg-gray-800 px-3 py-1.5 border border-gray-200 dark:border-gray-700 rounded-lg font-medium text-gray-800 dark:text-gray-100 text-sm",
                        className
                    )}
                    {...props}
                >
                    No Plan
                </span>
            );
        }

        const config = planConfig[plan.toLowerCase() as keyof typeof planConfig];

        if (!config) {
            return (
                <span
                    ref={ref}
                    className={cn(
                        "inline-flex items-center gap-1.5 bg-gray-100 dark:bg-gray-800 px-3 py-1.5 border border-gray-200 dark:border-gray-700 rounded-lg font-medium text-gray-800 dark:text-gray-100 text-sm capitalize",
                        className
                    )}
                    {...props}
                >
                    {plan.replace(/_/g, " ")}
                </span>
            );
        }

        return (
            <span
                ref={ref}
                className={cn(
                    "inline-flex items-center gap-1.5 px-3 py-1.5 border rounded-lg font-medium text-sm",
                    config.color,
                    className
                )}
                {...props}
            >
                <span>{config.icon}</span>
                <span>{config.label}</span>
            </span>
        );
    }
);

SubscriptionPlanBadge.displayName = "SubscriptionPlanBadge";

export { SubscriptionPlanBadge };
